(function () {
  const initFullHeightHeroes = () => {
    const heroes = document.querySelectorAll('[data-hero-full]');
    if (!heroes.length) return;

    const syncHeroOffset = () => {
      heroes.forEach((hero) => {
        const main = hero.closest('main');
        const mainTop = main ? main.getBoundingClientRect().top : 0;
        const offset = Math.max(0, Math.round(mainTop));
        hero.style.setProperty('--hero-viewport-offset', `${offset}px`);
      });
    };

    syncHeroOffset();
    window.addEventListener('resize', syncHeroOffset, { passive: true });
    window.addEventListener('orientationchange', syncHeroOffset, {
      passive: true,
    });
  };

  const initHeroScrollDownArrows = () => {
    const buttons = document.querySelectorAll('[data-hero-scroll-down]');
    if (!buttons.length) return;

    const getScrollOffset = () => {
      const stickyHeader = document.querySelector('header.sticky');
      const adminBar = document.getElementById('wpadminbar');
      let offset = 0;

      if (stickyHeader instanceof HTMLElement) {
        const rect = stickyHeader.getBoundingClientRect();
        if (rect.bottom > 0) {
          offset += Math.round(rect.height);
        }
      }

      if (adminBar instanceof HTMLElement) {
        const rect = adminBar.getBoundingClientRect();
        if (rect.bottom > 0) {
          offset += Math.round(rect.height);
        }
      }

      // Small breathing room so section content does not stick to the nav.
      return offset;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const heroSection = button.closest('section');
        let target = heroSection ? heroSection.nextElementSibling : null;

        while (target && !(target instanceof HTMLElement)) {
          target = target.nextElementSibling;
        }

        if (target instanceof HTMLElement) {
          const targetTop = window.scrollY + target.getBoundingClientRect().top;
          const scrollTop = Math.max(0, targetTop - getScrollOffset());

          window.scrollTo({
            top: scrollTop,
            behavior: 'smooth',
          });
          return;
        }

        window.scrollBy({
          top: Math.round(window.innerHeight * 0.75),
          behavior: 'smooth',
        });
      });
    });
  };

  const initHeroSection = () => {
    initFullHeightHeroes();
    initHeroScrollDownArrows();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeroSection);
  } else {
    initHeroSection();
  }
})();
